import { useNavigate } from "react-router";

import { Button } from "~/atoms/button";
import { AuthLayout } from "../../layouts/Auth";
import { useTranslation } from "react-i18next";

export const ResetPasswordComplete = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <AuthLayout
      title={t(($) => $.password.reset.title)}
      description={t(($) => $.password.reset.subText)}
    >
      <div className="pt-2">
        <Button className="" onClick={() => navigate("/login")}>
          {t(($) => $.password.backToLogin)}
        </Button>
      </div>
    </AuthLayout>
  );
};
